import React from "react";
import { FaHome } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Head, NavForPages } from "../components";
import { useI18n } from "../i18n";

const ErrorPage = () => {
  const { t } = useI18n();

  return (
    <>
      {/* noindex : une page d'erreur ne doit jamais entrer dans l'index */}
      <Head title={t.error.title} noindex />

      <section className="page">
        <NavForPages />
        <div className="error-page page-center">
          <div className="section-center ">
            <h1>{t.error.heading}</h1>
            <Link to="/" className="btn" title={t.error.back}>
              {t.error.back} <FaHome className="fa" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ErrorPage;
